import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import useScrollReset from './hooks/useScrollReset';
import routes from './routes';
import { createCustomTheme } from './theme';

const App = () => {
		const content = useRoutes(routes);

	useScrollReset();

	const theme = createCustomTheme({
		compact: true,
		direction: 'ltr',
		responsiveFontSizes: true,
		roundedCorners: true,
		theme: 'DARK'
	});

	return (
		<>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{content}
			</ThemeProvider>
		</>
	);
};

export default App;
